import React, { useState } from 'react';
import { featureFlagsModel } from '../../../../models/entities/businessPartner/settings';
import { settings, shipment } from '../../../../models/entities/shipment/shipment';
import Accounting from '../../commonSubEntities/accounting/Accounting';
import { billingLine } from '../../../../models/entities/common_subentities/billingLine';
import AccountingFormConnected from '../AccountingForm/AccountingFormConnected';
import ShipmentFinancialActions from './ShipmentFinancialActions';

type Props = {
    shipment: shipment;
    updateShipmentAccountingState: (shipmentId: string, shipmentAccountingState: string) => Promise<void>;
    billingLines?: Array<billingLine>;
    localization: any;
    settings?: settings;
    printMode?: boolean;
    featureFlags?: featureFlagsModel;
    cargoOwnerProfitSurchargePercent?: number | null;
    cargoOwnerBaseCurrency?: string | null;
    cargoOwnerVat?: number | null;
};

const ShipmentAccounting = ({
    shipment,
    updateShipmentAccountingState,
    billingLines,
    localization,
    settings,
    printMode,
    featureFlags,
    cargoOwnerProfitSurchargePercent,
    cargoOwnerBaseCurrency,
    cargoOwnerVat
}: Props) => {
    const [invoiceDetailsRefreshToken, setInvoiceDetailsRefreshToken] = useState(0);

    return (
        <Accounting<shipment, settings>
            entity={shipment}
            billingLines={billingLines}
            updateShipmentAccountingState={updateShipmentAccountingState}
            localization={localization}
            settings={settings}
            menuType="shipmentAccountingMenu"
            AccountingFormConnected={AccountingFormConnected}
            printMode={printMode}
            featureFlags={featureFlags}
            cargoOwnerProfitSurchargePercent={cargoOwnerProfitSurchargePercent}
            cargoOwnerBaseCurrency={cargoOwnerBaseCurrency}
            cargoOwnerVat={cargoOwnerVat}
            invoiceDetailsRefreshToken={invoiceDetailsRefreshToken}
            toolbarActions={
                !printMode ? (
                    <ShipmentFinancialActions
                        shipment={shipment}
                        onInvoiceSent={() => setInvoiceDetailsRefreshToken((t) => t + 1)}
                    />
                ) : undefined
            }
        />
    );
};

export default ShipmentAccounting;
